import { Component, OnInit } from '@angular/core';
import { CurrentOrdersService } from '../../../../core/services/current-orders.service';
import { WebSocketService } from '../../../../core/services/web-socket.service';
import { ActivatedRoute } from '@angular/router';
import { ORDER_READY_SPECIAL_MERCHANTS } from '../../../../core/constants';

@Component({
  selector: 'app-current-orders',
  templateUrl: './current-orders.component.html',
  styleUrls: ['./current-orders.component.scss'],
})
export class CurrentOrdersComponent implements OnInit {
  public isGroup: boolean;
  public specialLocation: boolean;
  public users = 0;
  public message = '';
  public messages: string[] = [];
  private locationId: string;
  private groupId: string;

  constructor(
    private currentOrdersService: CurrentOrdersService,
    private socketService: WebSocketService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (params.locationId) {
        this.locationId = params.locationId;
        this.initLocation();
      } else if (params.groupId) {
        this.groupId = params.groupId;
        this.isGroup = true;
        this.specialLocation = ORDER_READY_SPECIAL_MERCHANTS
          .some(location => location === params.groupId);
        this.initGroup();
      }
    });
  }

  private initLocation(): void {
    this.currentOrdersService.getOrders(this.locationId);
    this.currentOrdersService.getRestaurant(this.locationId).subscribe();
    this.socketService.connect({locationId: this.locationId});
    this.currentOrdersService.subscribeSocket();
  }
  private initGroup(): void {
    this.currentOrdersService.getGroupOrders(this.groupId);
    this.socketService.connect({locationId: this.groupId});
    this.currentOrdersService.subscribeGroupSocket();
  }
}
